import React from 'react';
import { Field, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { mdiCommentAlertOutline } from '@mdi/js';

import { Button, Toggler, Icons, WideAlert, Radio } from '@components';
import { RegimeTributarioSchema, RegimeTributarioValues } from '@schemas';
import { enviaFormRequest } from '@store/user/actions';

export const OpcaoRegimeTributacao = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <Formik
          validateOnMount
          initialValues={RegimeTributarioValues}
          validationSchema={RegimeTributarioSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <WideAlert className="mb-4" iconClear={false}>
                <div className="d-block d-lg-flex align-items-center">
                  <Icons
                    path={mdiCommentAlertOutline}
                    color="var(--primary-color)"
                    size={4}
                    style={{ marginRight: 4 }}
                  />
                  <p className="ts-16">
                    <strong>Aviso importante:</strong> esse é o serviço para
                    realizar a opção do Regime de Tributação em cima do Imposto
                    de Renda.
                    <p>
                      Caso ainda tenha dúvidas ou queira obter mais informações,
                      entre em contato com a nossa Central de Atendimento pelo
                      0800.090.9090 (segunda a sexta-feira, das 8h30 às 17h30)
                      ou atendimento@forluz.org.br
                    </p>
                  </p>
                </div>
              </WideAlert>

              <p className="mb-32">
                Escolha o Regime de Tributação do Imposto de Renda que será
                calculado no seu requerimento com base na Lei nº 11.053 de 2004,
                alterada pela Lei nº 14.803 de 2024. Essa Lei permite aos
                participantes de planos de previdência a escolha de seu regime
                de tributação na ocasião da obtenção do benefício ou do primeiro
                resgate dos valores acumulados.
              </p>

              <p className="mb-32">
                <strong>Formalizo a minha opção pelo Regime: </strong>
              </p>

              <div className="row">
                <Field
                  className="mb-5"
                  name="tipoRegime"
                  component={Radio}
                  value="Progressivo"
                  label="Progressivo: os valores recebidos da Forluz serão tributados conforme tabela para cálculo do Imposto de Renda (IR), o que significa que o desconto do imposto na fonte terá alíquotas variáveis conforme o montante recebido, ou seja, quanto maior o valor, maior a alíquota. Atualmente, as alíquotas variam de 0% a 27,5%. Nesse regime poderão ocorrer deduções mensais e ajustes na declaração anual de Imposto de Renda. "
                />
              </div>

              <div className="row">
                <Field
                  className="mb-3"
                  name="tipoRegime"
                  component={Radio}
                  value="Regressivo"
                  label="Regressivo: neste caso, o IR pago no recebimento da Forluz vai variar entre 35% e 10% de acordo com o tempo de aporte de recursos ao plano, ou seja, quanto maior o tempo, menor a alíquota. A tributação será exclusivamente na fonte, ou seja, não serão realizados ajustes anuais na declaração de Imposto de Renda. "
                />
              </div>

              <hr className="mt-32 mt-xs-0 mb-32" />
              <p className="mb-32 mt-32">
                <strong>Declarações</strong>
              </p>

              <div className="row">
                <Field
                  className="mb-3"
                  name="aceite"
                  component={Toggler}
                  label="Declaro ciência de que a opção marcada é IRRETRATÁVEL, ou seja, saques posteriores ou resgates terão a tributação calculada de acordo com essa escolha."
                />
              </div>

              <div className="row">
                <Field
                  className="mb-5"
                  name="declaracaoTipoRegime"
                  component={Toggler}
                  label="Declaro ciência de que caso já tenha feito algum resgate, será desconsiderada a opção marcada acima e será aplicado o regime escolhido no primeiro resgate. "
                />
              </div>

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
